import React from 'react';

export default function Divider() {
  return <div className="w-100" style={{ borderBottom: '1px solid #091e4221' }}></div>;
}
